// when disabled, disable input and dropdown, but not label. Except form is submitting

export function getFlatSelectFormikFieldControlDisabledProps({ isSubmitting }) {
  return isSubmitting ? { disabled: true } : null
}
